import React from 'react'
import SchemaForm from 'components/forms/SchemaForm'
import { connect } from 'react-redux'
import { consultationTypeSchema } from 'forms/admin/consultationTypeSchema'

class ConsultationTypeForm extends React.Component {
  render () {
    return (
      <SchemaForm entityName='consultationType' uiSchema={uiSchema} submitButton={true} entityId={this.props.entityId}/>
      )
  }
}

const mapStateToProps = (state, ownProps) => {
  return {
    submitButton: true,
    uiSchema: consultationTypeSchema(state, ownProps)
  }
}

export default connect(mapStateToProps)(ConsultationTypeForm);
